(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["calcel-wishlist"] && !Shopify.designMode) return;
  try {
    (() => {
    let frame = 0;
    let observedBar;
    const sizes = new ResizeObserver(schedule);

    function schedule() {
      if (!frame) frame = requestAnimationFrame(update);
    }

    function update() {
      frame = 0;
      // Wishlist can target Notify Me's button; restore its original sibling position.
      document.querySelectorAll('.buy-buttons-block add-to-cart-component > .nm-portal .swym-wishlist-button-bar').forEach((bar) => {
        const cart = bar.closest('add-to-cart-component');
        if (cart) cart.appendChild(bar);
      });
      document.querySelectorAll('.buy-buttons-block .swym-add-to-wishlist').forEach((button) => {
        const label = button.querySelector('.swym-wishlist-cta');
        if (label && label.textContent !== 'KEEP IT') label.textContent = 'KEEP IT';
        const name = button.getAttribute('aria-pressed') === 'true' ? 'KEEP IT（保存済み）' : 'KEEP IT';
        if (button.getAttribute('aria-label') !== name) button.setAttribute('aria-label', name);
      });

      const copy = [
        ['.swym-storefront-layout-grid-item-add-to-cart-button', 'ADD TO CART'],
        ['.swym-storefront-layout-login-heading', 'ログインして自分だけのリスト作成ができます'],
        ['.swym-storefront-layout-login-description', '新規会員登録でクーポンをプレゼント🎁'],
      ];
      copy.forEach(([selector, text]) => {
        document.querySelectorAll(selector).forEach((element) => {
          // Preserve loading, sold-out and other app states on the cart button.
          if (selector.includes('add-to-cart') && element.textContent.trim() !== 'カートに追加') return;
          if (element.textContent !== text) element.textContent = text;
        });
      });
      // Replace only text nodes so app links, arrows and click handlers survive.
      const emptyCopy = [
        ['.swym-storefront-layout-empty-wishlist-title', '閲覧しながら保存', 'マイリストに保存'],
        ['.swym-storefront-layout-empty-wishlist-description', '任意の商品で♡をタップ。ここに保存されるので失いません。', 'ADD TO WISHLISTで保存できます。'],
        ['.swym-storefront-layout-empty-state-login-cta', 'ログインして永続的に保存', 'ログインして自分だけのリストを作成'],
        ['.swym-storefront-layout-empty-state-signup-text', 'アカウントをお持ちでないですか？', 'アカウントをお持ちでないですか？新規会員登録でクーポンをプレゼント🎁'],
      ];
      emptyCopy.forEach(([selector, original, replacement]) => {
        document.querySelectorAll(selector).forEach((element) => {
          element.childNodes.forEach((node) => {
            if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() === original) {
              const lines = selector.endsWith('login-cta')
                ? ['ログインして', '自分だけのリストを作成']
                : selector.endsWith('signup-text')
                  ? ['アカウントをお持ちでないですか？', '新規会員登録で', 'クーポンをプレゼント🎁']
                  : null;
              if (lines) {
                const label = document.createElement('span');
                lines.forEach((text) => {
                  const line = document.createElement('span');
                  line.className = 'calcel-wishlist-copy-line';
                  line.textContent = text;
                  label.append(line);
                });
                node.replaceWith(label);
              } else {
                node.textContent = node.textContent.replace(original, replacement);
              }
            }
          });
        });
      });

      const loginTemplate = document.getElementById('calcel-wishlist-login-template');
      document.querySelectorAll('.swym-storefront-layout-shop-login-container').forEach((container) => {
        if (loginTemplate && !container.querySelector('.calcel-wishlist-login')) {
          container.append(loginTemplate.content.cloneNode(true));
        }
      });

      const bar = document.querySelector('sticky-add-to-cart [ref="stickyBar"]');
      if (bar !== observedBar) {
        sizes.disconnect();
        if (bar) sizes.observe(bar);
        observedBar = bar;
      }
      const anchor = document.querySelector('#swym-anchor[data-position^="bottom"]');
      if (!anchor) return;
      let bottom = 10;
      if (bar && bar.dataset.stuck === 'true' && getComputedStyle(bar).display !== 'none') {
        // Use the resting height/bottom, not the animated transform position.
        bottom = Math.ceil(bar.offsetHeight + (parseFloat(getComputedStyle(bar).bottom) || 0) + 12);
      }
      const value = `${bottom}px`;
      if (anchor.style.getPropertyValue('--calcel-wishlist-bottom') !== value) {
        anchor.style.setProperty('--calcel-wishlist-bottom', value);
      }
    }

    // The app injects/replaces buttons after load and when variants change.
    new MutationObserver(schedule).observe(document.body, {
      subtree: true, childList: true, characterData: true, attributes: true,
      attributeFilter: ['aria-pressed', 'data-stuck'],
    });
    window.addEventListener('resize', schedule, { passive: true });
    document.addEventListener('shopify:section:load', schedule);
    schedule();
  })();
  } catch(e) { console.error(e); }
})();

})();
